import { render, staticRenderFns } from "./ScaniaNextGenDisplay.vue?vue&type=template&id=110a530f&"
import script from "./ScaniaNextGenDisplay.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports